import React, { useState, useMemo, useRef, useEffect, useReducer } from 'react'
import ListItemIcon from '@mui/material/ListItemIcon';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { useForm, Controller } from "react-hook-form";
import { SellerInfoUpdate } from '../sellers/SellerInfoUpdate';
import {
    Card,
    Table,
    Stack,
    Paper,
    Avatar,
    Button,
    Container,
    Typography,
    IconButton,
    TableContainer,
    TablePagination,
    // ListItemIcon,
    Box,
    TextField,
    Tooltip,
    Menu,
    CardContent,

} from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Grid from '@mui/material/Grid'
import CircularProgress from '@mui/material/CircularProgress';
import Iconify from '../../components/iconify';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import Pagination from '@mui/material/Pagination';
import { ProductList } from '../../sections/@dashboard/products';
import SellerSideNav from './SellerSideNav';
import SellerHeader from './Header';
import { FoodMenuEdite } from './components/MenuEdit';
import { FoodMenuCreate } from './components/MenuCreate';
import { AlertDialog } from '../../utils/dealog/diloag';
import { AccountUpdate } from '../sellers/SellerAccountUpdate';

import { showError, showSuccess } from '../../utils/toast';
import { UpdateStoreImg } from './components/UpdateStoreImg';
// Redux Api Call
import { useGetSallerInfoApiMutation, useGetFoodMenuMutation, useGetFoodDeleteApiMutation, useGetFoodSearchMutation } from '../../redux/services/seller/sellerInfo';
import { useGetSubCategoryQuery, useGetCategoryQuery } from '../../redux/services/common/Common';

const SellerStatus = ({ seller }) => {

    if (seller.verified) {
        return (
            <Tooltip title="Verified">
                <Button >
                    <ListItemIcon style={{ justifyContent: "center", color: "greenyellow" }}>
                        <Iconify icon="bxs:user-check" width={24} height={24} />
                    </ListItemIcon>
                </Button>
            </Tooltip>
        )
    }

    return (
        <Tooltip title="Not Verified">
            <Button >
                <ListItemIcon style={{ justifyContent: "center", color: "red" }}>
                    <Iconify icon="bxs:user-x" width={24} height={24} />
                </ListItemIcon>
            </Button>
        </Tooltip>
    )


}
const SellerInfo = () => {
    const navigate = useNavigate();
    const [sellerInfoData, setSellerInfoData] = useState()
    const [selectedFood, setSelectedFood] = useState(null);
    const [loadMenu, setLoadMenu] = useState(true)
    const [addFood, setAddFood] = useState(null)
    const [deletFood, setDeleteFood] = useState(null)
    const [reloadDdata, ForReloadData] = useReducer(x => x + 1, 0)
    const [selectedFilter, setSelectedFilter] = useState('All');
    const [searchQuery, setSearchQuery] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [open, setOpen] = useState(false)
    const [updateSellerOpen, setUpdateSellerOpen] = useState(null);
    const [updateaccount, setUpdateAccount] = useState(null)
    const [sortByData, setSortByData] = useState("NEW");
    const [sortSubCategory, setSortsortSubCategory] = useState(null);
    const [sortCategory, setSortsortCategory] = useState(null);

    const [activeFood, setActiveFood] = useState(null);
    const [selectApproval, setSelectApproval] = useState(null);
    const [active, setActive] = useState();
    const [Approval, setApproval] = useState();

    // pegnition
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);

    // Redux Api Call 
    const [getSellerInfo] = useGetSallerInfoApiMutation();
    const [getFoodMenu, foodList] = useGetFoodMenuMutation();
    const [getFoodDelete, FoodDelete] = useGetFoodDeleteApiMutation();
    const [getFoodSearch] = useGetFoodSearchMutation();
    const { data: subCatogry } = useGetCategoryQuery();
    const { data: Catogry } = useGetSubCategoryQuery(sortSubCategory);


    // eslint-disable-next-line no-undef
    const [foodMenu, setFoodMenu] = useState([])

    // Id sellerInfo
    const { id } = useParams();


    const deleteMessege = useRef()
    const deleteTitle = useRef()
    const deleteFood = useRef()




    const onCancleDeleteFood = () => {
        setDeleteFood(false)
    }

    const handleChangePrice = (e) => {
        setSortByData(e.target.value)
    }
    const handleChangeApproval = (e) => {
        setSelectApproval(e.target.value)
    }
    const handleChangePActiveFood = (e) => {
        setActiveFood(e.target.value)
    }
    const handleChangeSubCategory = (e) => {
        setSortsortSubCategory(e.target.value)
    }
    const handleChangeCategory = (e) => {
        setSortsortCategory(e.target.value)
    }
    const handleFilterSelection = (filter) => {
        setSelectedFilter(filter);
    };



    const handleStoreImgOpen = () => {
        setOpen(true)
    }

    const handleStoreImgClose = () => {
        setOpen(false)
    }






    //   Seller Daitel Api Fatching
    const sallerInfoData = async () => {
        console.log("sellerInfoId", id)
        const body = {
            id: id,
        };
        try {
            const sallerData = await getSellerInfo(body);
            console.log("sellerDaitell", sallerData.data.sellers)
            // if (sallerData && sallerData.data.seller) {
            setSellerInfoData(sallerData.data.sellers)
            // }
            setLoadMenu(true)
        } catch (error) {
            console.log("Error fetching data:", error);
        }
    }





    // food menu Api 
    const foodmenuData = async () => {

        const food = {
            page: currentPage,
            seller: [id],
            sortBy: sortByData,
            category: [sortCategory],



        }
        try {
            const foodmenuData = await getFoodMenu(food);
            const { total, current, list } = foodmenuData.data;
            setFoodMenu(list)
            setTotalItems(total);
            setCurrentPage(current);
            setIsLoading(true)


        } catch (error) {
            console.log("Error fetching data:", error);
        }
        finally {
            setIsLoading(false);
        }
    };
    const onDeleteFood = (product) => {
        console.log('productDelete', product)
        deleteTitle.current = "Do You Want Delete Food?"
        deleteFood.current = product.id
        console.log('foodId', product.id)
        deleteMessege.current = `Food ${product.name}`
        setDeleteFood(product)
    }


    const onFoodDelete = async () => {
        const food_id = deleteFood.current
        const seller_id = id
        try {
            await getFoodDelete({ seller_id, food_id });
            setDeleteFood(null)
            ForReloadData()


        } catch (error) {
            console.error("Error deleting food item", error);
        }
    };

    useEffect(() => {
        if (FoodDelete.isSuccess) {
            showSuccess('Food Delete Success')
            FoodDelete.reset()
        }
        if (FoodDelete.isError) {
            showError(FoodDelete.error.data.msg)
            FoodDelete.reset()
        }

    }, [FoodDelete])

    // Food Search
    const handleSearch = async (query) => {

        setIsLoading(true);
        try {
            const search = {
                query: query,
                page: currentPage,
            };

            const foodsearch = await getFoodSearch(search);
            setFoodMenu(foodsearch.data.list);


        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleInputSearch = (event) => {
        const value = event.target.value;
        setSearchQuery(value);
        if (value.trim() === '') {
            foodmenuData();
        } else {
            handleSearch(value);
        }
    };

    // Filter FoodMenu
    // eslint-disable-next-line array-callback-return
    const filteredMenu = foodMenu.filter((item) => {
        if (selectedFilter === 'All') {
            return true;
        } if (selectedFilter === 'V') {
            return item.type === 'V';
        } if (selectedFilter === 'N') {
            return item.type === 'N';
        } if (selectedFilter === 'E') {
            return item.type === 'E';
        }
    });

    // filte Button systel
    const getFilterButtonStyle = (filter) => selectedFilter === filter ? { backgroundColor: 'blue', color: 'white' } : {};

    const getFilterSortButtonStyle = (filter) => sortByData === filter ? { backgroundColor: 'green', color: 'white' } : {};


    useEffect(() => {
        sallerInfoData()
        foodmenuData()
    }, [reloadDdata, loadMenu, currentPage, sortByData])


    // pigmetion handle pages
    const handlePageChange = (event, newPage) => {
        setCurrentPage(newPage);
    };


    return (
        <>
            <Grid container spacing={2}>
                {/* Seller SideNav */}
                <Grid item xs={12} sm={6} md={3} mt={2}>
                    <Box>
                        <SellerSideNav seller={sellerInfoData} load={ForReloadData} />
                    </Box>
                </Grid>
                {/* Seller Information */}
                <Grid item xs={12} sm={6} md={9} p={1}>
                    <br />
                    <Card>
                        <CardContent>
                            <SellerHeader seller={sellerInfoData} />
                            <Stack direction="row" mb={5} mt={5} sx={{ display: "flex", justifyContent: 'end' }}>
                                <Button onClick={handleStoreImgOpen}>
                                    <Iconify icon="bx:camera" width={24} height={24} color="blue" />
                                </Button>
                                <Button onClick={() => { setUpdateSellerOpen(sellerInfoData) }}>
                                    <Iconify icon="eva:edit-fill" width={24} height={24} color="blue" />
                                </Button>
                                <Box sx={{ padding: "3px" }}>
                                    <Button variant='outlined' onClick={() => { setUpdateAccount(sellerInfoData) }}>
                                        Update Account
                                    </Button>
                                </Box>
                                <Box sx={{ padding: "3px" }}>
                                    <Button variant='outlined'>
                                        Payment
                                    </Button>
                                </Box>
                                <Box sx={{ padding: "3px" }}>
                                    <Button variant='outlined'>
                                        Delete
                                    </Button>
                                </Box>
                            </Stack>
                        </CardContent>
                    </Card>
                    <Card sx={{ marginTop: "10px" }}>
                        <CardContent>

                            <Container>
                                <Grid container spacing={1} sx={{ display: 'flex', justifyContent: "end" }} mt={2}>
                                    <Grid item xs={2} mt={2}>
                                        <FormControl fullWidth >
                                            <InputLabel id="demo-simple-select-label">Other Pages</InputLabel>
                                            <Select
                                                variant="outlined"
                                                margin="dense"
                                                size="small"
                                                label="Other Pages"
                                                name="Other Pages"
                                                select
                                            >
                                                <MenuItem component={Link} to="/dashboard/user">User</MenuItem>
                                                <MenuItem component={Link} to="/dashboard/ordar">Order</MenuItem>
                                                <MenuItem component={Link} to="/dashboard/deliver">Deliver</MenuItem>

                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={2} mt={2}>
                                        <FormControl fullWidth >
                                            <InputLabel id="demo-simple-select-label">Price</InputLabel>
                                            <Select
                                                margin="dense"
                                                variant="outlined"
                                                label="SortBy"
                                                name="SortBy"
                                                size="small"
                                                value={sortByData}
                                                onChange={handleChangePrice}
                                            >
                                                <MenuItem value={'PHL'}>High Price</MenuItem>
                                                <MenuItem value={'PLH'}>Low Price</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={2} mt={2}>
                                        <FormControl fullWidth>
                                            <InputLabel id="demo-simple-select-label">Category</InputLabel>
                                            <Select
                                                margin="dense"
                                                variant="outlined"
                                                label="Category"
                                                name="Category"
                                                size="small"
                                                value={sortSubCategory}
                                                onChange={handleChangeSubCategory}
                                            >
                                                {subCatogry && subCatogry?.data?.map((opetion) => <MenuItem key={opetion?.id} value={opetion?.id}>{opetion?.name}</MenuItem>)}

                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={2} mt={2}>
                                        <FormControl fullWidth>
                                            <InputLabel id="demo-simple-select-label">SubCategory</InputLabel>
                                            <Select
                                                margin="dense"
                                                variant="outlined"
                                                label="Category"
                                                name="Category"
                                                size="small"

                                                value={sortCategory}
                                                onChange={handleChangeCategory}
                                            >

                                                {Catogry && Catogry?.data?.map((opetion) => <MenuItem key={opetion?.id} value={opetion?.id}>{opetion?.name}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={3} mt={2}>
                                        <Box>
                                            <TextField
                                                variant="outlined"
                                                label="Search"
                                                placeholder="Search..."
                                                size="small"
                                                value={searchQuery}
                                                onChange={handleInputSearch}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton aria-label="search" disabled={isLoading}>
                                                                <SearchIcon sx={{ color: 'blue' }} />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                                {/* Filter and Food List */}
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={6} md={10}>
                                        <Stack direction="row" alignItems="center" spacing={2} mt={5} mb={5}>
                                            {/* Filter Buttons */}
                                            <Button
                                                variant="outlined"
                                                onClick={() => handleFilterSelection('All')}
                                                style={getFilterButtonStyle("All")}
                                            >
                                                All
                                            </Button>
                                            <Button variant="outlined"
                                                onClick={() => handleFilterSelection('V')}
                                                style={getFilterButtonStyle('V')}
                                            >
                                                Veg
                                            </Button>
                                            <Button variant="outlined"
                                                onClick={() => handleFilterSelection('N')}
                                                style={getFilterButtonStyle('N')}
                                            >
                                                Non-Veg
                                            </Button>
                                            <Button variant="outlined"
                                                onClick={() => handleFilterSelection('E')}
                                                style={getFilterButtonStyle('E')}
                                            >
                                                Egg
                                            </Button>
                                            <Button variant="outlined"
                                                color='inherit'
                                                onClick={() => setSortByData('NEW')}
                                                style={getFilterSortButtonStyle('NEW')}
                                            >
                                                NEW
                                            </Button>
                                            <Button variant="outlined"
                                                color='inherit'
                                                onClick={() => setSortByData('OFR')}
                                                style={getFilterSortButtonStyle('OFR')}
                                            >
                                                OFFER
                                            </Button>
                                        </Stack>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={2} mt={4} mb={5}>
                                        <Button variant="contained" onClick={setAddFood} startIcon={<Iconify icon="eva:plus-fill" />}>
                                            Add Food
                                        </Button>
                                    </Grid>
                                </Grid>
                                {/* Food List */}
                                {foodList.isLoading ? (
                                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                        <CircularProgress />
                                    </Box>
                                ) : (
                                    <ProductList products={filteredMenu} openModal={setSelectedFood} onDelete={onDeleteFood} load={ForReloadData} reLoad={reloadDdata} />
                                )}
                                <br />
                                {/* Pagination Controls */}
                                <Box mt={3} sx={{ display: 'flex', justifyContent: 'center' }}>
                                    <Pagination
                                        count={totalItems}
                                        page={currentPage}
                                        onChange={handlePageChange}
                                        className="pagination-root"
                                    />
                                </Box>
                                <br />
                            </Container>
                        </CardContent>
                    </Card>
                    <br />
                    <br />
                </Grid>
            </Grid>

            <FoodMenuCreate reloadData={ForReloadData} create={addFood} setCreate={setAddFood} sellerid={id} setLoadMenu={setLoadMenu} />
            <FoodMenuEdite reloadData={ForReloadData} food={selectedFood} setFood={setSelectedFood} setLoadMenu={setLoadMenu} />
            <AlertDialog open={deletFood} onCancel={onCancleDeleteFood} onClick={onCancleDeleteFood} message={deleteMessege} title={deleteTitle} onOkey={onFoodDelete} />
            <UpdateStoreImg open={open} onClose={handleStoreImgClose} reloadData={ForReloadData} sellerid={sellerInfoData} />
            <SellerInfoUpdate update={updateSellerOpen} setUpdate={setUpdateSellerOpen} setLoad={ForReloadData} />
            <AccountUpdate update={updateaccount} setUpdate={setUpdateAccount} setLoad={ForReloadData} />

        </>
    )
}

export default SellerInfo













